query getChildCrmCompaniesWithProvider {
  config: getChildCrmCompaniesWithProvider {
    id
    name
    enforceMasterConnection
    acceptedMasterConnection
  }
}
